import "./404.module.css";
import NotFoundSEO from "../../components/SEO/NotFoundSEO";

const NotFound = () => {
  return (
    <>
      <NotFoundSEO />
      <div className="not-found">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you are looking for could not be found.</p>
        <a href="/">Go back to homepage</a>
      </div>
    </>
  );
};

export default NotFound;
